import { IonPage } from '@ionic/react';
import React from 'react';
import { useParams } from 'react-router';
import { Content } from '../components/content';
import './contentpage.scss';

export const ContentPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  return (
    <IonPage>
      <Content slug={slug} key={slug} />
    </IonPage>
  );
};
